import { useState } from 'react'
import Modal from '@components/Modal'
import Button from '@components/Button'
import styles from './styles.module.scss'

const OnDemandParkingIntroModal = ({ initialShowModal }) => {
    const [showModal, setShowModal] = useState(initialShowModal)

    if (!showModal) return null

    return (
        <Modal size="large" onClose={() => setShowModal(false)}>
            <div className="d-flex flex-column align-items-center">
                <div className={styles.introGif} />
                <h3 className="font-weight-bold mb-3">
                    <T>dashboard.on.demand.parking.intro.title</T>
                </h3>
                <p className="text-large text-center mb-5">
                    <T>dashboard.on.demand.parking.intro.description</T>
                </p>
                <Button onClick={() => setShowModal(false)}>
                    <T>dashboard.on.demand.parking.intro.continue</T>
                </Button>
            </div>
        </Modal>
    )
}

export default OnDemandParkingIntroModal
